module.exports = __webpack_public_path__ + "a7e03cc3310077db66228d5dc8e2d67b.svg";